import React from 'react';
import './App.css';
import BuildingAnimation from './BuildingAnimation';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="container">
          <div className="logo-section">
            <h1 className="logo">RapidLynx</h1>
            <div className="logo-dot"></div>
          </div>


          <div className="content-section">
            <h2 className="tagline">Innovation at Light Speed</h2>


            <div className="animation-section">
              <BuildingAnimation />
            </div>

            <div className="coming-soon">
              <span className="status-badge">Coming Soon</span>
            </div>

            <div className="construction-message">
              <p>The wait may be long, but we’re building with hope — and it will be worth it.</p>
            </div>


            <div className="contact-section">
              <p className="early-access-text">
                Want to know more? Email us at <a href="mailto:admin@rapidlynx.io" className="email-link">admin@rapidlynx.io</a> for updates.
              </p>
            </div>
          </div>
{/* 
          <div>
            <p>
              Kuku is cute! ♥
            </p>
          </div> */}


          <div className="quote-section">
            <blockquote className="quote">
              <p>"Pain and suffering are always inevitable for a large intelligence and a deep heart. The really great men must, I think, have great sadness on earth."</p>
              <cite>― Fyodor Dostoevsky</cite>
            </blockquote>
          </div>

          <footer className="footer">
            <p>&copy; 2025 RapidLynx. All rights reserved.</p>
          </footer>
        </div>
      </header>
    </div>
  );
}

export default App;